import { useEffect, useState } from 'react';

const VISITOR_COOKIE_NAME = '_visitor_type';

/**
 * Hook to manage visitor type (new vs returning)
 * Sets a cookie on first visit and updates it on subsequent visits
 */
export function useVisitorCookie(): 'new' | 'returning' {
  const [visitorType, setVisitorType] = useState<'new' | 'returning'>('new');

  useEffect(() => {
    if (typeof document === 'undefined') return;

    // Check for existing cookie
    const cookies = document.cookie.split('; ');
    const visitorCookie = cookies.find((row) => row.startsWith(`${VISITOR_COOKIE_NAME}=`));

    if (visitorCookie) {
      // Returning visitor
      setVisitorType('returning');
    } else {
      // New visitor - set the cookie
      setVisitorType('new');

      // Set cookie with 2 year expiry
      const expiryDate = new Date();
      expiryDate.setFullYear(expiryDate.getFullYear() + 2);

      document.cookie = `${VISITOR_COOKIE_NAME}=returning; expires=${expiryDate.toUTCString()}; path=/; SameSite=Lax`;
    }
  }, []);

  return visitorType;
}
